import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './par-accommodation-type.reducer'; // Assurez-vous que le chemin est correct
import { IParAccommodationType } from 'app/shared/model/par-accommodation-type.model'; // Assurez-vous que le modèle est correct
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ParAccommodationType = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const parAccommodationTypeList = useAppSelector(state => state.parAccommodationType.entities);
  const loading = useAppSelector(state => state.parAccommodationType.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="par-accommodation-type-heading" data-cy="ParAccommodationTypeHeading">
        <Translate contentKey="almobadaraMasterDataApp.parAccommodationType.home.title">Par Accommodation Types</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="almobadaraMasterDataApp.parAccommodationType.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="almobadaraMasterDataApp.parAccommodationType.home.createLabel">
              Create new Par Accommodation Type
            </Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {parAccommodationTypeList && parAccommodationTypeList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parAccommodationType.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parAccommodationType.code">Code</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parAccommodationType.name">Name</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parAccommodationType.nameAr">Name ar</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parAccommodationType.nameEn">Name en</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parAccommodationType.status">Status</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {parAccommodationTypeList.map((parAccommodationType, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${parAccommodationType.id}`} color="link" size="sm">
                      {parAccommodationType.id}
                    </Button>
                  </td>
                  <td>{parAccommodationType.code}</td>
                  <td>{parAccommodationType.name}</td>
                  <td>{parAccommodationType.nameAr}</td>
                  <td>{parAccommodationType.nameEn}</td>
                  <td>
                    <Translate contentKey={`almobadaraMasterDataApp.Status.${parAccommodationType.status}`} />
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`${match.url}/${parAccommodationType.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${parAccommodationType.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${parAccommodationType.id}/delete`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Archive</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="almobadaraMasterDataApp.parAccommodationType.home.notFound">
                No Par Accommodation Types found
              </Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default ParAccommodationType;
